<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 8L7.33333 9.33333L10.3333 6.33333M4.88918 2.5458C5.42507 2.50303 5.93381 2.2923 6.34298 1.94361C7.29782 1.12991 8.70218 1.12991 9.65702 1.94361C10.0662 2.2923 10.5749 2.50303 11.1108 2.5458C12.3614 2.64559 13.3544 3.63863 13.4542 4.88918C13.497 5.42507 13.7077 5.93381 14.0564 6.34298C14.8701 7.29782 14.8701 8.70218 14.0564 9.65702C13.7077 10.0662 13.497 10.5749 13.4542 11.1108C13.3544 12.3614 12.3614 13.3544 11.1108 13.4542C10.5749 13.497 10.0662 13.7077 9.65702 14.0564C8.70218 14.8701 7.29782 14.8701 6.34298 14.0564C5.93381 13.7077 5.42507 13.497 4.88918 13.4542C3.63863 13.3544 2.64559 12.3614 2.5458 11.1108C2.50303 10.5749 2.2923 10.0662 1.94361 9.65702C1.12991 8.70218 1.12991 7.29782 1.94361 6.34298C2.2923 5.93381 2.50303 5.42507 2.5458 4.88918C2.64559 3.63863 3.63863 2.64559 4.88918 2.5458Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
